import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import TextareaAutosize from 'react-textarea-autosize';

import './SelectorTextArea.css';

class SelectorTextArea extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    dataTestLabel: PropTypes.string,
    name: PropTypes.string,
    placeHolder: PropTypes.string,
    maxLength: PropTypes.string,
    defaultValue: PropTypes.string,
    isDisabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    tabIndex: PropTypes.string,
    onChangeEvent: PropTypes.func,
    onBlurEvent: PropTypes.func,
    edited: PropTypes.bool
  }

  static defaultProps = {
    title: '',
    dataTestLabel: 'data-test-id-textarea',
    name: '',
    placeHolder: '',
    maxLength: '',
    defaultValue: '',
    readOnly: false,
    isDisabled: false,
    tabIndex: '',
    onChangeEvent: null,
    onBlurEvent: null,
    edited: false
  }

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue
    };
  }

  componentDidUpdate(prevProps) {
    const { defaultValue } = this.props;
    const { defaultValue: oldValue } = prevProps;

    if (defaultValue === oldValue) return;

    this.setStateOnly();
  }

  setStateOnly = () => {
    const { defaultValue } = this.props;

    this.setState({
      value: defaultValue
    });
  }

  handleOnChange = (event) => {
    if (!event || !event.target) return;

    const { value } = event.target;

    this.setState({
      value
    }, () => {
      if (this.props.onChangeEvent === null) return;

      this.props.onChangeEvent(value);
    });
  }

  handleOnBlur = (event) => {
    const { value } = this.state;
    const { defaultValue, onBlurEvent } = this.props;

    if (onBlurEvent === null) return;

    if (!event || !event.target) return;

    if (defaultValue === value) return;

    onBlurEvent(value);
  }

  render() {
    const {
      title,
      tabIndex,
      dataTestLabel,
      name,
      placeHolder,
      maxLength,
      isDisabled,
      readOnly,
      edited
    } = this.props;

    const { value } = this.state;

    const customClassName = `custom-textarea-component ${edited ? 'edited' : ''}`;
  
    return (
      <Row className="selector-textarea-component h-100 auto-margin">
        <Col sm="12" className="component-title no-padding-left">{title}</Col>
        <Col sm="12" className="component-form no-padding align-self-end">
          {(readOnly)
            ?
              <label className="read-only-label">
                {value}
              </label>
            :
              <TextareaAutosize
                tabIndex={tabIndex}
                className={customClassName}
                data-test-id={dataTestLabel}
                name={name}
                value={value}
                placeholder={placeHolder}
                maxLength={maxLength}
                disabled={isDisabled}
                onChange={this.handleOnChange}
                onBlur={this.handleOnBlur}
              />
          }
        </Col>
      </Row>
    );
  }
};

export default SelectorTextArea;
